module.exports = __webpack_public_path__ + "static/media/primaryFire.b258cc19.png";